// App.js
import React from 'react';
import './App.css';
import './global.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoginModule from './components/Login/LoginModule';
import Sidebar from './components/Sidebar/Sidebar';
import { store, persistor } from "./store";
import ToastProvider from './components/Sidebar/ToastProvider';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from "react-redux";
import OrganizationRegistration from './components/Login/Ragistration';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import KycSuccess from './components/Sidebar/Pages/KycSuccess';
import { PermissionProvider } from './components/contexts/PermissionContext';
import { SuspensionProvider } from './components/contexts/SuspensionContext';

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <PermissionProvider>
          <SuspensionProvider>
            <ToastProvider>
            <BrowserRouter>
              <Routes>
                <Route path='/*' element={<LoginModule />} />
                <Route path='/registration' element={<OrganizationRegistration/>} />
                <Route path='/home/*' element={<Sidebar />} />
                <Route path="/digitalKYC/callback" element={<KycSuccess />} />
              </Routes>
            </BrowserRouter>
            <ToastContainer />
            </ToastProvider>
          </SuspensionProvider>
        </PermissionProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
